import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance2,
  API_END_POINTS,
} from 'api';

import { MESSAGES } from 'appconstants';

import {
  SUBSCRIPTION_BUTTONV2DETAILS,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';


const fetchSubscriptionButtonV2Details = async gid => axiosAuthInstance2.get(`${API_END_POINTS.SUBSCRIPTION_BUTTON}/${gid}`);

const DeactiveSubscriptionV2Button = async gid => axiosAuthInstance2.patch(`${API_END_POINTS.SUBSCRIPTION_BUTTON}/${gid}/deactivate`);

const patchSubscriptionButtonV2 = async ({ gid, params }) => axiosAuthInstance2.patch(`${API_END_POINTS.SUBSCRIPTION_BUTTON}/${gid}`, params);

const fetchSubscriptionButtonV2Payments = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const queryParam = `&subscription2Button.gid.EQ=${payload.gid}`;
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  return axiosAuthInstance2.get(`${API_END_POINTS.SUBSCRIPTION}${query}${queryParam}${sorting}`);
};

export function* getSubscriptionButtonV2Details(action) {
  try {
    yield put({ type: LOADING.SET });
    const { data: { entity } } = yield call(fetchSubscriptionButtonV2Details, action.payload);
    yield put({ type: SUBSCRIPTION_BUTTONV2DETAILS.SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: SUBSCRIPTION_BUTTONV2DETAILS.FAILED, payload: e.response.data });
  } finally {
    yield put({ type: LOADING.UNSET });
  }
}

export function* getSubscriptionButtonV2List(action) {
  try {
    const { data: { entity } } = yield call(fetchSubscriptionButtonV2Payments, action.payload);
    yield put({ type: SUBSCRIPTION_BUTTONV2DETAILS.PAYMENTS_SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: SUBSCRIPTION_BUTTONV2DETAILS.FAILED, payload: e.response.data });
  }
}

export function* deactiveSubscriptionV2Button(action) {
  try {
    yield put({ type: LOADING.VALIDATING });
    yield put({ type: LOADING.SUBMITTING });
    yield call(DeactiveSubscriptionV2Button, action.payload);
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.SUBSCRIPTION_BUTTON.DELETE_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}

export function* updateSubscriptionButtonV2(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(patchSubscriptionButtonV2, action.payload);
    const { data: { entity } } = yield call(fetchSubscriptionButtonV2Details, action.payload.gid);
    yield put({ type: SUBSCRIPTION_BUTTONV2DETAILS.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.SUBSCRIPTION_BUTTON.UPDATE_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}
